;(function () {
  'use strict'
  angular
    .module('contrast.servers')
    .controller(
      'ModalApplyProtectionLicenseInstanceCtrl',
      ModalApplyProtectionLicenseInstanceCtrl
    )

  function ModalApplyProtectionLicenseInstanceCtrl(
    $scope,
    $uibModalInstance,
    $translate,
    logger,
    servers,
    updateProtection,
    UserService,
    ServerService
  ) {
    'ngInject'

    angular.extend($scope, {
      model: {
        servers: servers
      }
    })

    angular.extend($scope, {
      applyLicense: applyLicense,
      cancel: cancel,
      isFreemium: UserService.isFreemiumOrganization
    })

    function applyLicense() {
      ServerService.applyLicense(servers).then(function (result) {
        var licensesApplied = result.licensesApplied
        var msg = $translate.instant(
          'plural_servers_protectLicensesApplied',
          { count: licensesApplied },
          'messageformat'
        )

        logger.logSuccess(msg)
        $uibModalInstance.close()
      })
    }

    function cancel() {
      if (updateProtection) {
        for (var i = 0; i < $scope.model.servers.length; i++) {
          $scope.model.servers[i].defend = !$scope.model.servers[i].defend
        }
      }

      $uibModalInstance.dismiss('cancel')
    }
  }
})()
